function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useQuery, useLazyQuery } from "@apollo/client";
import React, { useState } from "react";
import Badge from "react-bootstrap/Badge";
import ProgressBar from "react-bootstrap/ProgressBar";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import classNames from "classnames";
import moment from "moment-timezone";
import { FilterContext, SearchContext } from "../index";
import { MY_TEAM_QUERY, MY_TEAM_HEADER_QUERY, MY_TEAM_LEAVE_DETAILS_QUERY } from "./query";
import "./MyTeams.css";
import Loader from "./../Loader/Loader";
import { arrayToStringOutput } from "./../SideMenu/Header";
import { MdLaptop } from "react-icons/md";
import { HiOutlineRefresh } from "react-icons/hi";
import { BillingDueExtendedMsg, BillingBankTrasferPlanEndBeforeMsg } from "./../Billing/Billing";
import { WarningCardOrgTimezone } from "./../Dashboard/Dashboard";
var LIMIT = 21;
var allOffsets = 0;
var currentlyWorkingoffsets = 0;
var breakOffsets = 0;
var stopOffsets = 0;
var yetToStartOffsets = 0;
var appNotInstalledOffsets = 0;
var searchOffsets = 0;
var leaveOffsets = 0;
var leaveRefreshOffsets = 0;
var MyTeams = function MyTeams(props) {
  var _myTeamsHeaderData$my, _myTeamsData$myTeam;
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _useState = useState("all"),
    _useState2 = _slicedToArray(_useState, 2),
    filterId = _useState2[0],
    setFilterId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAllLoaded = _useState4[0],
    setIsAllLoaded = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCurrentlyWorkingLoaded = _useState6[0],
    setIsCurrentlyWorkingLoaded = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isBreakLoaded = _useState8[0],
    setIsBreakLoaded = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isStopLoaded = _useState10[0],
    setIsStopLoaded = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isYetToStartLoaded = _useState12[0],
    setIsYetToStartLoaded = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isAppNotInstallLoaded = _useState14[0],
    setIsAppNotInstallLoaded = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isLeaveLoaded = _useState16[0],
    setIsLeaveLoaded = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isLoadingMore = _useState18[0],
    setIsLoadingMore = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isLoadMoreButton = _useState20[0],
    setIsLoadMoreButton = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isGettingData = _useState22[0],
    setIsGettingData = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    refetchStatus = _useState24[0],
    setRetchStatus = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isRefreshClicked = _useState26[0],
    setIsRefreshClicked = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    leaveData = _useState28[0],
    setLeaveData = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    leaveLoading = _useState30[0],
    setLeaveLoading = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    leaveError = _useState32[0],
    setLeaveError = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    leaveCurrentOffset = _useState34[0],
    setLeaveCurrentOffset = _useState34[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    organisationBilling = _React$useContext.organisationBilling,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(SearchContext),
    search = _React$useContext2.search,
    setSearch = _React$useContext2.setSearch;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var _useQuery = useQuery(MY_TEAM_HEADER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        dateString: dateFilter,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: role
      },
      skip: !organisationId || !teamId
    }),
    myTeamsHeaderData = _useQuery.data,
    myTeamsHeaderError = _useQuery.error,
    myTeamsHeaderLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  var _useQuery2 = useQuery(MY_TEAM_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        dateString: dateFilter,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        filter: filterId,
        limit: LIMIT,
        offset: 0,
        userRole: role,
        searchText: search
      },
      skip: !organisationId || !teamId
    }),
    myTeamsLoading = _useQuery2.loading,
    myTeamsData = _useQuery2.data,
    myTeamsError = _useQuery2.error,
    fetchMore = _useQuery2.fetchMore,
    myTeamRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(MY_TEAM_LEAVE_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        dateString: dateFilter,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        filter: filterId,
        limit: LIMIT,
        offset: leaveCurrentOffset,
        userRole: role,
        searchText: search
      },
      fetchPolicy: "network-only"
      // notifyOnNetworkStatusChange: true,
      //   skip: !teamId && !organisationId,
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getMyTeamLeaveDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    myTeamLeaveData = _useLazyQuery2$.data,
    myTeamLeaveError = _useLazyQuery2$.error,
    myTeamLeaveLoading = _useLazyQuery2$.loading,
    myTeamLeaveLoadingFetchMore = _useLazyQuery2$.fetchMore;

  // React.useEffect(() => {
  //   getMyTeamLeaveDetails();
  // }, [leaveCurrentOffset]);

  React.useEffect(function () {
    if (myTeamLeaveLoading) {
      if (leaveCurrentOffset <= 0) {
        setLeaveLoading(true);
      }
    } else if (myTeamLeaveData) {
      var _myTeamLeaveData$myTe, _myTeamLeaveData$myTe2, _myTeamLeaveData$myTe3, _myTeamLeaveData$myTe4, _myTeamLeaveData$myTe5, _myTeamLeaveData$myTe6, _myTeamLeaveData$myTe7, _myTeamLeaveData$myTe8;
      // Update the data in your local state

      if (leaveCurrentOffset > 0) {
        setIsLoadingMore(false);
      }
      if ((myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe === void 0 ? void 0 : (_myTeamLeaveData$myTe2 = _myTeamLeaveData$myTe.myTeamMembers) === null || _myTeamLeaveData$myTe2 === void 0 ? void 0 : _myTeamLeaveData$myTe2.length) === 0 && (myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe3 = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe3 === void 0 ? void 0 : (_myTeamLeaveData$myTe4 = _myTeamLeaveData$myTe3.myTeamMembers) === null || _myTeamLeaveData$myTe4 === void 0 ? void 0 : _myTeamLeaveData$myTe4.length) < LIMIT || (myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe5 = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe5 === void 0 ? void 0 : (_myTeamLeaveData$myTe6 = _myTeamLeaveData$myTe5.myTeamMembers) === null || _myTeamLeaveData$myTe6 === void 0 ? void 0 : _myTeamLeaveData$myTe6.length) !== 0 && (myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe7 = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe7 === void 0 ? void 0 : (_myTeamLeaveData$myTe8 = _myTeamLeaveData$myTe7.myTeamMembers) === null || _myTeamLeaveData$myTe8 === void 0 ? void 0 : _myTeamLeaveData$myTe8.length) < LIMIT) {
        getOffsetValue();
      }
      if (leaveCurrentOffset == 0) {
        var _myTeamLeaveData$myTe9;
        setLeaveData(_toConsumableArray(myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe9 = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe9 === void 0 ? void 0 : _myTeamLeaveData$myTe9.myTeamMembers));
      } else {
        setLeaveData(function (prevData) {
          var _myTeamLeaveData$myTe10;
          return [].concat(_toConsumableArray(prevData), _toConsumableArray(myTeamLeaveData === null || myTeamLeaveData === void 0 ? void 0 : (_myTeamLeaveData$myTe10 = myTeamLeaveData.myTeamLeaveDetails) === null || _myTeamLeaveData$myTe10 === void 0 ? void 0 : _myTeamLeaveData$myTe10.myTeamMembers));
        });
      }
      setLeaveLoading(false);
    } else if (myTeamLeaveError) {
      setLeaveError(myTeamLeaveError);
      setLeaveLoading(false);
    }
  }, [myTeamLeaveLoading, myTeamLeaveData, myTeamLeaveError]);
  React.useEffect(function () {
    allOffsets = 0;
    currentlyWorkingoffsets = 0;
    breakOffsets = 0;
    stopOffsets = 0;
    yetToStartOffsets = 0;
    appNotInstalledOffsets = 0;
    searchOffsets = 0;
    leaveOffsets = 0;
    leaveRefreshOffsets = 0;
    setRetchStatus(true);
    setIsAllLoaded(false);
    setIsCurrentlyWorkingLoaded(false);
    setIsBreakLoaded(false);
    setIsStopLoaded(false);
    setIsYetToStartLoaded(false);
    setIsAppNotInstallLoaded(false);
    setIsLeaveLoaded(false);
    myTeamRefetch === null || myTeamRefetch === void 0 ? void 0 : myTeamRefetch();
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key, teamId, startDate, endDate]);
  React.useEffect(function () {
    if (myTeamsData && !myTeamsLoading) {
      setIsGettingData(true);
      setRetchStatus(false);
    }
  }, [myTeamsData]);
  var getOffsetValueFalse = function getOffsetValueFalse(value) {
    if (value == "all") {
      setIsAllLoaded(false);
    } else if (value == "start") {
      setIsCurrentlyWorkingLoaded(false);
    } else if (value == "break") {
      setIsBreakLoaded(false);
    } else if (value == "stop") {
      setIsStopLoaded(false);
    } else if (value == "yet_to_start") {
      setIsYetToStartLoaded(false);
    } else if (value == "app_not_installed") {
      setIsAppNotInstallLoaded(false);
    } else if (value == "leave") {
      setIsLeaveLoaded(false);
    }
  };
  React.useEffect(function () {
    searchOffsets = 0;
    getOffsetValueFalse(filterId);
  }, [search]);
  if (myTeamsHeaderLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (myTeamsHeaderError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!myTeamsHeaderData) {
    return null;
  }

  //console.log("props.location.key test6", props.location);

  //const myTeamDetailsData = myTeamsData?.myTeam?.myTeamMembers;
  var teamStatusCountData = myTeamsHeaderData === null || myTeamsHeaderData === void 0 ? void 0 : (_myTeamsHeaderData$my = myTeamsHeaderData.myTeamHeader) === null || _myTeamsHeaderData$my === void 0 ? void 0 : _myTeamsHeaderData$my.teamStatusCount;

  // const teamWithSearch = (teamsData) => {
  //   if (!search) {
  //     return teamsData;
  //   }

  //   return teamsData.filter((filterTeamsData) =>
  //     filterTeamsData?.user?.displayName?.toLowerCase?.()?.includes?.(search.toLowerCase())
  //   );
  // };
  //console.log( organisationSettings.trackAppsWebsites,organisationSettings.enableProjectManagement);

  var getOffsetValue = function getOffsetValue() {
    if (filterId == "all" && isGettingData) {
      //console.log("funct all ,isGettingData",isGettingData);
      setIsAllLoaded(true);
    } else if (filterId == "start" && isGettingData) {
      //console.log("funct start isGettingData",isGettingData);
      setIsCurrentlyWorkingLoaded(true);
    } else if (filterId == "break" && isGettingData) {
      //console.log("funct break isGettingData",isGettingData);
      setIsBreakLoaded(true);
    } else if (filterId == "stop" && isGettingData) {
      //console.log("funct stop isGettingData",isGettingData);
      setIsStopLoaded(true);
    } else if (filterId == "yet_to_start" && isGettingData) {
      //console.log("funct yet_to_start isGettingData",isGettingData);
      setIsYetToStartLoaded(true);
    } else if (filterId == "app_not_installed" && isGettingData) {
      //console.log("funct app_not_installed isGettingData",isGettingData);
      setIsAppNotInstallLoaded(true);
    } else if (filterId == "leave" && isGettingData) {
      //console.log("funct app_not_installed isGettingData",isGettingData);
      setIsLeaveLoaded(true);
    }
  };
  var handleLoadMore = function handleLoadMore() {
    if (myTeamsLoading) return;
    setIsLoadingMore(true);
    var offsets = 0;
    if (filterId == "all") {
      if (!search.length) {
        allOffsets = allOffsets + 1;
        offsets = allOffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "start") {
      if (!search.length) {
        currentlyWorkingoffsets = currentlyWorkingoffsets + 1;
        offsets = currentlyWorkingoffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "break") {
      if (!search.length) {
        breakOffsets = breakOffsets + 1;
        offsets = breakOffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "stop") {
      if (!search.length) {
        stopOffsets = stopOffsets + 1;
        offsets = stopOffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "yet_to_start") {
      if (!search.length) {
        yetToStartOffsets = yetToStartOffsets + 1;
        offsets = yetToStartOffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "app_not_installed") {
      if (!search.length) {
        appNotInstalledOffsets = appNotInstalledOffsets + 1;
        offsets = appNotInstalledOffsets;
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    } else if (filterId == "leave") {
      if (!search.length) {
        leaveOffsets = leaveOffsets + 1;
        offsets = leaveOffsets;
        if (isRefreshClicked) {
          leaveRefreshOffsets = leaveRefreshOffsets + 1;
          offsets = leaveRefreshOffsets;
        }
      } else {
        searchOffsets = searchOffsets + 1;
        offsets = searchOffsets;
      }
    }
    if (!isRefreshClicked) {
      fetchMore({
        variables: {
          offset: offsets * LIMIT
        },
        updateQuery: function updateQuery(prev, _ref) {
          var _fetchMoreResult$myTe, _fetchMoreResult$myTe2, _fetchMoreResult$myTe3, _fetchMoreResult$myTe4;
          var fetchMoreResult = _ref.fetchMoreResult;
          if (!fetchMoreResult) return prev;
          if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$myTe = fetchMoreResult.myTeam) === null || _fetchMoreResult$myTe === void 0 ? void 0 : (_fetchMoreResult$myTe2 = _fetchMoreResult$myTe.myTeamMembers) === null || _fetchMoreResult$myTe2 === void 0 ? void 0 : _fetchMoreResult$myTe2.length) === 0 && fetchMoreResult.myTeam.myTeamMembers.length < LIMIT || (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$myTe3 = fetchMoreResult.myTeam) === null || _fetchMoreResult$myTe3 === void 0 ? void 0 : (_fetchMoreResult$myTe4 = _fetchMoreResult$myTe3.myTeamMembers) === null || _fetchMoreResult$myTe4 === void 0 ? void 0 : _fetchMoreResult$myTe4.length) !== 0 && fetchMoreResult.myTeam.myTeamMembers.length < LIMIT) {
            getOffsetValue();
          }
          setIsLoadingMore(false);
          return _objectSpread(_objectSpread({}, prev), {}, {
            myTeam: _objectSpread(_objectSpread({}, prev.myTeam), {}, {
              myTeamMembers: [].concat(_toConsumableArray(prev.myTeam.myTeamMembers), _toConsumableArray(fetchMoreResult.myTeam.myTeamMembers))
            })
          });
        }
      });
    } else {
      setLeaveCurrentOffset(function (prevPage) {
        return (prevPage + 1) * LIMIT;
      });
    }
  };
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var currentSystemDate = moment().tz(currentTimezone).format("MMMM DD");
  var orgTimezoneDate = moment().tz(organisationSettings.organisationTimezone).format("MMMM DD");
  return /*#__PURE__*/React.createElement("div", {
    className: "my-team-root"
  }, role != "Member" ? /*#__PURE__*/React.createElement(BillingDueExtendedMsg, {
    failedPlanEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.failedPlanEnd,
    billingPeriodEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.billingPeriodEnd,
    handleCheckout: null,
    pageName: "dashboard",
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, role != "Member" ? /*#__PURE__*/React.createElement(BillingBankTrasferPlanEndBeforeMsg, {
    beforePlanEndAlert: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.beforePlanEndAlert,
    planEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planEnd,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    paymentType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType
  }) : null, dateFilter == "Today" && currentSystemDate != orgTimezoneDate ? /*#__PURE__*/React.createElement(WarningCardOrgTimezone, {
    currentSystemDate: currentSystemDate,
    orgTimezoneDate: orgTimezoneDate,
    currentSystemTimezone: currentTimezone,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "my-team-root-filter-button my-team-root-filter-button-".concat(filterId)
  }, teamStatusCountData.map(function (item) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: " ",
      className: "rounded-pill px-3 team-status-filter ".concat(filterId === item.value ? "team-status-filter-selected" : null),
      size: "sm"
      // active={productivityStatus === "productive"}
      ,
      onClick: function onClick() {
        //console.log("button onclick", item.value);
        setIsRefreshClicked(false);
        setFilterId(item.value);
        getOffsetValueFalse(item.value);
        setIsGettingData(false);
        searchOffsets = 0;
        setSearch("");
        // console.log("offsetsValue",offsetsValue);
        //setIsAllLoaded(false);
        // getMyTeamData({
        //   variables: {
        //     organisationId,
        //     teamId,
        //     startDate: Number(moment(startDate).format("x")),
        //     endDate: Number(moment(endDate ?? startDate).format("x")),
        //     dateString: dateFilter,
        //     timeZone: organisationSettings?.organisationTimezone,
        //     filter: item.value,
        //     limit: LIMIT,
        //     offset: 0,
        //   },
        // });
      }
      // disabled={loading}
    }, item.label, " ", !search.length && item.count > 0 ? "(".concat(item.count, ")") : "");
  })), /*#__PURE__*/React.createElement(TeamMembersCardListing, {
    myTeamDetailsDataFilter: isRefreshClicked ? leaveData : myTeamsData === null || myTeamsData === void 0 ? void 0 : (_myTeamsData$myTeam = myTeamsData.myTeam) === null || _myTeamsData$myTeam === void 0 ? void 0 : _myTeamsData$myTeam.myTeamMembers
    //teamWithSearch={teamWithSearch}
    ,
    Link: Link,
    linkProps: linkProps,
    dateFilter: dateFilter,
    organisationSettings: organisationSettings,
    myTeamsLoading: leaveLoading || myTeamsLoading || refetchStatus,
    myTeamsError: leaveError || myTeamsError,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    isCurrentlyWorkingLoaded: isCurrentlyWorkingLoaded,
    isBreakLoaded: isBreakLoaded,
    isStopLoaded: isStopLoaded,
    isYetToStartLoaded: isYetToStartLoaded,
    isAppNotInstallLoaded: isAppNotInstallLoaded,
    filterId: filterId,
    getOffsetValue: getOffsetValue,
    setIsGettingData: setIsGettingData,
    search: search,
    isLeaveLoaded: isLeaveLoaded,
    getMyTeamLeaveDetails: getMyTeamLeaveDetails,
    setIsRefreshClicked: setIsRefreshClicked,
    setIsLeaveLoaded: setIsLeaveLoaded,
    organisationId: organisationId,
    teamId: teamId,
    startDate: startDate,
    endDate: endDate,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    userRole: role,
    leaveCurrentOffset: leaveCurrentOffset,
    setLeaveCurrentOffset: setLeaveCurrentOffset
  }));
};
var TeamMembersCardListing = function TeamMembersCardListing(props) {
  var myTeamDetailsDataFilter = props.myTeamDetailsDataFilter,
    Link = props.Link,
    linkProps = props.linkProps,
    dateFilter = props.dateFilter,
    organisationSettings = props.organisationSettings,
    myTeamsLoading = props.myTeamsLoading,
    myTeamsError = props.myTeamsError,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    isCurrentlyWorkingLoaded = props.isCurrentlyWorkingLoaded,
    isBreakLoaded = props.isBreakLoaded,
    isStopLoaded = props.isStopLoaded,
    isYetToStartLoaded = props.isYetToStartLoaded,
    isAppNotInstallLoaded = props.isAppNotInstallLoaded,
    filterId = props.filterId,
    getOffsetValue = props.getOffsetValue,
    setIsGettingData = props.setIsGettingData,
    search = props.search,
    isLeaveLoaded = props.isLeaveLoaded,
    getMyTeamLeaveDetails = props.getMyTeamLeaveDetails,
    setIsRefreshClicked = props.setIsRefreshClicked,
    organisationId = props.organisationId,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    userRole = props.userRole,
    setIsLeaveLoaded = props.setIsLeaveLoaded,
    leaveCurrentOffset = props.leaveCurrentOffset,
    setLeaveCurrentOffset = props.setLeaveCurrentOffset;
  if (myTeamsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (myTeamsError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!myTeamDetailsDataFilter) {
    return null;
  }
  if (myTeamDetailsDataFilter.length !== 0 && myTeamDetailsDataFilter.length < LIMIT
  //&&
  // (
  //   (filterId =="all" && !isAllLoaded) || (filterId =="start" && !isCurrentlyWorkingLoaded) || (filterId =="break" && !isBreakLoaded) || (filterId =="stop" && !isStopLoaded) || (filterId =="yet_to_start" && !isYetToStartLoaded) || (filterId =="app_not_installed" && !isAppNotInstallLoaded)
  // ) && !myTeamsLoading
  ) {
    // setIsAllLoaded(true);
    getOffsetValue();
  }
  var handleLeaveRefreshButton = function handleLeaveRefreshButton() {
    setLeaveCurrentOffset(0);
    setIsLeaveLoaded(false);
    setIsRefreshClicked(true);
    getMyTeamLeaveDetails();
    // getMyTeamLeaveDetails();
    //   {
    //   variables: {
    //     organisationId,
    //     teamId,
    //     startDate: Number(moment(startDate).format("x")),
    //     endDate: Number(moment(endDate ?? startDate).format("x")),
    //     dateString: dateFilter,
    //     timeZone,
    //     filter: filterId,
    //     limit: LIMIT,
    //     offset: 0,
    //     userRole,
    //     searchText: search,
    //   },
    //   // fetchPolicy: "network-only",
    // }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "team-card-root-my-teams"
  }, myTeamDetailsDataFilter.length === 0 && !search.length ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, filterId == "leave" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "team-card-root-leave-details-refresh-text"
  }, "Once your team members start to apply for leave on workfolio, you will see the data here."), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    className: "team-card-root-leave-details-refresh-button team-card-root-leave-details-refresh-button-no-member",
    onClick: function onClick() {
      return handleLeaveRefreshButton();
    }
  }, /*#__PURE__*/React.createElement(HiOutlineRefresh, {
    className: "team-card-root-leave-details-refresh-icon"
  }), "Refresh"), " ") : "No team members found") : search.length && (myTeamDetailsDataFilter === null || myTeamDetailsDataFilter === void 0 ? void 0 : myTeamDetailsDataFilter.length) === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No team members found for \"".concat(search, "\"")) : /*#__PURE__*/React.createElement(React.Fragment, null, filterId == "leave" ? /*#__PURE__*/React.createElement("div", {
    className: "team-card-root-leave-details-refresh-root"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    className: "team-card-root-leave-details-refresh-button",
    onClick: function onClick() {
      return handleLeaveRefreshButton();
    }
  }, /*#__PURE__*/React.createElement(HiOutlineRefresh, {
    className: "team-card-root-leave-details-refresh-icon"
  }), "Refresh"), " ") : null, /*#__PURE__*/React.createElement("div", {
    className: "team-card-root"
  }, myTeamDetailsDataFilter.map(function (teamCardValue) {
    var _teamCardValue$leaveS, _teamCardValue$recent, _teamCardValue$recent2, _teamCardValue$leaveS2, _teamCardValue$leaveS3, _teamCardValue$leaveS4, _teamCardValue$recent3, _teamCardValue$recent4, _teamCardValue$leaveS5, _teamCardValue$leaveS6, _teamCardValue$recent5, _teamCardValue$recent6, _teamCardValue$recent7, _teamCardValue$recent8, _teamCardValue$recent9, _teamCardValue$recent10, _teamCardValue$recent11, _teamCardValue$recent12, _teamCardValue$user, _teamCardValue$leaveS7, _teamCardValue$recent13, _teamCardValue$recent14, _teamCardValue$leaveS8, _teamCardValue$recent15, _teamCardValue$user2, _teamCardValue$user3, _teamCardValue$user3$, _teamCardValue$user4, _teamCardValue$leaveS9, _teamCardValue$recent16, _teamCardValue$recent17, _teamCardValue$recent18, _teamCardValue$leaveS10, _teamCardValue$recent19, _teamCardValue$recent20, _teamCardValue$leaveS11, _teamCardValue$leaveS12, _teamCardValue$leaveS13, _teamCardValue$leaveS14, _teamCardValue$leaveS15, _teamCardValue$leaveS16, _teamCardValue$user5, _teamCardValue$user6, _teamCardValue$recent21, _teamCardValue$recent22, _teamCardValue$recent23, _teamCardValue$recent24, _teamCardValue$user7, _teamCardValue$leaveS17, _teamCardValue$leaveS18, _teamCardValue$leaveS19, _teamCardValue$leaveS20, _teamCardValue$leaveS21, _teamCardValue$leaveS22, _teamCardValue$user8, _teamCardValue$recent25, _teamCardValue$recent26, _teamCardValue$recent27, _teamCardValue$recent28, _teamCardValue$recent29, _teamCardValue$user9, _teamCardValue$user10, _teamCardValue$user11;
    if (teamCardValue.recentWorkStatus.status == "stealthmode") {
      return;
    }
    var workLastActivity = ((_teamCardValue$leaveS = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS === void 0 ? void 0 : _teamCardValue$leaveS.status) == "leave" && (filterId == "leave" || filterId != "leave" && (((_teamCardValue$recent = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent === void 0 ? void 0 : _teamCardValue$recent.status) === "yet_to_start" || ((_teamCardValue$recent2 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent2 === void 0 ? void 0 : _teamCardValue$recent2.status) === "app_not_installed")) ? /*#__PURE__*/React.createElement("span", null, ((_teamCardValue$leaveS2 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS2 === void 0 ? void 0 : _teamCardValue$leaveS2.appliedStatus) == "applied" ? "has ".concat((_teamCardValue$leaveS3 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS3 === void 0 ? void 0 : _teamCardValue$leaveS3.appliedStatus) : "on ".concat((_teamCardValue$leaveS4 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS4 === void 0 ? void 0 : _teamCardValue$leaveS4.appliedStatus), " ", ((_teamCardValue$recent3 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent3 === void 0 ? void 0 : _teamCardValue$recent3.status) != "yet_to_start" && ((_teamCardValue$recent4 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent4 === void 0 ? void 0 : _teamCardValue$recent4.status) != "app_not_installed" ? ((_teamCardValue$leaveS5 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS5 === void 0 ? void 0 : _teamCardValue$leaveS5.type) == "half-day-second-half" ? "second half leave" : ((_teamCardValue$leaveS6 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS6 === void 0 ? void 0 : _teamCardValue$leaveS6.type) == "half-day-first-half" ? "first half leave" : "full day leave" : "leave", " ", /*#__PURE__*/React.createElement("span", {
      className: "my-team-members-card-leave-label-date-display"
    }, dateFilter)) : dateFilter === "Today" ? ((_teamCardValue$recent5 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent5 === void 0 ? void 0 : _teamCardValue$recent5.status) === "yet_to_start" || ((_teamCardValue$recent6 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent6 === void 0 ? void 0 : _teamCardValue$recent6.status) === "app_not_installed" ? "Yet to start work" : "".concat(((_teamCardValue$recent7 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent7 === void 0 ? void 0 : _teamCardValue$recent7.status) === "stop" ? "stopped work" : ((_teamCardValue$recent8 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent8 === void 0 ? void 0 : _teamCardValue$recent8.status) === "break" ? "Took break" : "".concat((_teamCardValue$recent9 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent9 === void 0 ? void 0 : _teamCardValue$recent9.status, "ed work"), " ").concat(((_teamCardValue$recent10 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent10 === void 0 ? void 0 : _teamCardValue$recent10.time) === "just now" ? (_teamCardValue$recent11 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent11 === void 0 ? void 0 : _teamCardValue$recent11.time : "".concat((_teamCardValue$recent12 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent12 === void 0 ? void 0 : _teamCardValue$recent12.time, " ago")) : teamCardValue.workedDays === 0 ? "Yet to start work" : "Worked for ".concat(teamCardValue.workedDays, " day").concat(teamCardValue.workedDays > 1 ? "s" : "");
    return /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(teamCardValue.user.uniqueUrl)), {
      key: "team-".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user = teamCardValue.user) === null || _teamCardValue$user === void 0 ? void 0 : _teamCardValue$user.uniqueUrl)
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames("team-card", ((_teamCardValue$leaveS7 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS7 === void 0 ? void 0 : _teamCardValue$leaveS7.status) == "leave" && (filterId == "leave" || filterId != "leave" && (((_teamCardValue$recent13 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent13 === void 0 ? void 0 : _teamCardValue$recent13.status) === "yet_to_start" || ((_teamCardValue$recent14 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent14 === void 0 ? void 0 : _teamCardValue$recent14.status) === "app_not_installed")) ? (_teamCardValue$leaveS8 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS8 === void 0 ? void 0 : _teamCardValue$leaveS8.status : (_teamCardValue$recent15 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent15 === void 0 ? void 0 : _teamCardValue$recent15.status)
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-card-header"
    }, teamCardValue.user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "team-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user2 = teamCardValue.user) === null || _teamCardValue$user2 === void 0 ? void 0 : _teamCardValue$user2.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "team-card-avatar"
    }, teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user3 = teamCardValue.user) === null || _teamCardValue$user3 === void 0 ? void 0 : (_teamCardValue$user3$ = _teamCardValue$user3.displayName) === null || _teamCardValue$user3$ === void 0 ? void 0 : _teamCardValue$user3$.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: "team-card-name"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-team-name"
      }, teamCardValue.user.displayName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-card-teammembername"
    }, teamCardValue.user.displayName)), workLastActivity.length >= 35 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user4 = teamCardValue.user) === null || _teamCardValue$user4 === void 0 ? void 0 : _teamCardValue$user4.userId, "-activity"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, " ")
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-card-teammemberstatus"
    }, workLastActivity)) : /*#__PURE__*/React.createElement("div", {
      className: "team-card-teammemberstatus"
    }, workLastActivity)), /*#__PURE__*/React.createElement("div", {
      className: "team-card-percentage"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("team-card-percent", {
        "high-percent": teamCardValue.activePercentage > 50,
        "low-percent": teamCardValue.activePercentage <= 50
      })
    }, teamCardValue.activePercentage, "%"), /*#__PURE__*/React.createElement("div", {
      className: "team-card-percent-text"
    }, "Active Time"))), organisationSettings.trackAppsAndWebsites || organisationSettings.projectManagementFeature ? ((_teamCardValue$leaveS9 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS9 === void 0 ? void 0 : _teamCardValue$leaveS9.status) == "leave" && (filterId == "leave" || filterId != "leave" && (((_teamCardValue$recent16 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent16 === void 0 ? void 0 : _teamCardValue$recent16.status) === "yet_to_start" || ((_teamCardValue$recent17 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent17 === void 0 ? void 0 : _teamCardValue$recent17.status) === "app_not_installed")) ? /*#__PURE__*/React.createElement("div", {
      className: "team-card-badges"
    }, ((_teamCardValue$recent18 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent18 === void 0 ? void 0 : _teamCardValue$recent18.status) == "start" ? /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-leave team-card-badges-start-leave-data-badge"
    }, (_teamCardValue$leaveS10 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS10 === void 0 ? void 0 : _teamCardValue$leaveS10.appliedStatus, " leave, still currently working") : ((_teamCardValue$recent19 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent19 === void 0 ? void 0 : _teamCardValue$recent19.status) == "break" || ((_teamCardValue$recent20 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent20 === void 0 ? void 0 : _teamCardValue$recent20.status) == "stop" ? /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-leave team-card-badges-start-leave-data-badge"
    }, (_teamCardValue$leaveS11 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS11 === void 0 ? void 0 : _teamCardValue$leaveS11.appliedStatus, " leave, still worked") : /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-leave team-card-badges-no-data-badge"
    }, ((_teamCardValue$leaveS12 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS12 === void 0 ? void 0 : _teamCardValue$leaveS12.type) == "half-day-second-half" ? "".concat((_teamCardValue$leaveS13 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS13 === void 0 ? void 0 : _teamCardValue$leaveS13.appliedStatus, " second half leave") : ((_teamCardValue$leaveS14 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS14 === void 0 ? void 0 : _teamCardValue$leaveS14.type) == "half-day-first-half" ? "".concat((_teamCardValue$leaveS15 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS15 === void 0 ? void 0 : _teamCardValue$leaveS15.appliedStatus, " first half leave") : "".concat((_teamCardValue$leaveS16 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS16 === void 0 ? void 0 : _teamCardValue$leaveS16.appliedStatus, " full day leave"))) : teamCardValue.desktopAppStatus === "Desktop app installed" ? /*#__PURE__*/React.createElement("div", {
      className: "team-card-badges"
    }, organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(React.Fragment, null, dateFilter !== "Today" ? (teamCardValue === null || teamCardValue === void 0 ? void 0 : teamCardValue.projectCount) !== 0 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user5 = teamCardValue.user) === null || _teamCardValue$user5 === void 0 ? void 0 : _teamCardValue$user5.userId, "-project"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Worked Projects Count")
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-projectname "
    }, teamCardValue === null || teamCardValue === void 0 ? void 0 : teamCardValue.projectCount, " project", (teamCardValue === null || teamCardValue === void 0 ? void 0 : teamCardValue.projectCount) > 1 ? "s" : null, " worked")) : /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start"
    }, "No data") : teamCardValue.recentProject ? /*#__PURE__*/React.createElement(React.Fragment, null, teamCardValue.recentProject !== null && teamCardValue.recentTask !== null ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user6 = teamCardValue.user) === null || _teamCardValue$user6 === void 0 ? void 0 : _teamCardValue$user6.userId, "-project"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, (_teamCardValue$recent21 = teamCardValue.recentProject) === null || _teamCardValue$recent21 === void 0 ? void 0 : _teamCardValue$recent21.projectName, " :", " ", (_teamCardValue$recent22 = teamCardValue.recentTask) === null || _teamCardValue$recent22 === void 0 ? void 0 : _teamCardValue$recent22.taskName)
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-projectname team-card-badges-projectname-badge"
    }, /*#__PURE__*/React.createElement(MdLaptop, {
      className: "team-card-badges-app-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "team-card-badges-app-title"
    }, (_teamCardValue$recent23 = teamCardValue.recentProject) === null || _teamCardValue$recent23 === void 0 ? void 0 : _teamCardValue$recent23.projectName, " :", " ", (_teamCardValue$recent24 = teamCardValue.recentTask) === null || _teamCardValue$recent24 === void 0 ? void 0 : _teamCardValue$recent24.taskName))) :
    // <Badge className="team-card-badges-projectname team-card-badges-no-task-badge">
    //   <span className="team-card-badges-app-title">No task started</span>
    // </Badge>
    null) :
    // <Badge className="team-card-badges-projectname team-card-badges-no-task-badge">
    //   <span className="team-card-badges-app-title">No task started</span>
    // </Badge>
    null) : null, organisationSettings.trackAppsAndWebsites ? /*#__PURE__*/React.createElement(React.Fragment, null, dateFilter !== "Today" ? (teamCardValue === null || teamCardValue === void 0 ? void 0 : teamCardValue.userAppsCount) !== 0 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user7 = teamCardValue.user) === null || _teamCardValue$user7 === void 0 ? void 0 : _teamCardValue$user7.userId, "-user"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Used Apps Count")
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-projectname "
    }, teamCardValue === null || teamCardValue === void 0 ? void 0 : teamCardValue.userAppsCount, " apps used")) : /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start"
    }, "No data") : teamCardValue.recentApp ? /*#__PURE__*/React.createElement(React.Fragment, null, teamCardValue.recentApp !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, ((_teamCardValue$leaveS17 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS17 === void 0 ? void 0 : _teamCardValue$leaveS17.status) == "leave" ? /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-leave team-card-badges-no-data-badge"
    }, ((_teamCardValue$leaveS18 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS18 === void 0 ? void 0 : _teamCardValue$leaveS18.type) == "half-day-second-half" ? "".concat((_teamCardValue$leaveS19 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS19 === void 0 ? void 0 : _teamCardValue$leaveS19.appliedStatus, " second half leave") : ((_teamCardValue$leaveS20 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS20 === void 0 ? void 0 : _teamCardValue$leaveS20.type) == "half-day-first-half" ? "".concat((_teamCardValue$leaveS21 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS21 === void 0 ? void 0 : _teamCardValue$leaveS21.appliedStatus, " first half leave") : "".concat((_teamCardValue$leaveS22 = teamCardValue.leaveStatus) === null || _teamCardValue$leaveS22 === void 0 ? void 0 : _teamCardValue$leaveS22.appliedStatus, " full day leave")) : null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user8 = teamCardValue.user) === null || _teamCardValue$user8 === void 0 ? void 0 : _teamCardValue$user8.userId, "-user"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Currently used app")
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-projectname team-card-badges-app-name-badge"
    }, /*#__PURE__*/React.createElement("img", {
      src: (_teamCardValue$recent25 = teamCardValue.recentApp) === null || _teamCardValue$recent25 === void 0 ? void 0 : _teamCardValue$recent25.icon,
      className: "team-card-badges-app-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "team-card-badges-app-title"
    }, (_teamCardValue$recent26 = teamCardValue.recentApp) === null || _teamCardValue$recent26 === void 0 ? void 0 : _teamCardValue$recent26.app)))) : null) : teamCardValue.recentApp === null && teamCardValue.recentProject === null && teamCardValue.recentTask === null ? /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start team-card-badges-no-data-badge badge ".concat(teamCardValue.recentApp === null && (((_teamCardValue$recent27 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent27 === void 0 ? void 0 : _teamCardValue$recent27.status) == "start" || ((_teamCardValue$recent28 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent28 === void 0 ? void 0 : _teamCardValue$recent28.status) == "stop" | ((_teamCardValue$recent29 = teamCardValue.recentWorkStatus) === null || _teamCardValue$recent29 === void 0 ? void 0 : _teamCardValue$recent29.status) == "break") ? "team-card-badges-no-data-badge-hidden" : "")
    }, /*#__PURE__*/React.createElement("span", {
      className: "team-card-badges-app-title"
    }, "Yet to Start")) : /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start team-card-badges-no-data-badge badge"
    }, /*#__PURE__*/React.createElement("span", {
      className: "team-card-badges-app-title"
    }, "No data"))) : null) : teamCardValue.desktopAppStatus === "Desktop app not installed" ? /*#__PURE__*/React.createElement("div", {
      className: "team-card-badges"
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-desktop-not-installed team-card-badges-no-data-badge"
    }, teamCardValue.desktopAppStatus)) : /*#__PURE__*/React.createElement("div", {
      className: "team-card-badges"
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start team-card-badges-no-data-badge"
    }, "Tracking diabled")) : /*#__PURE__*/React.createElement("div", {
      className: "team-card-badges"
    }, /*#__PURE__*/React.createElement(Badge, {
      className: "team-card-badges-yet-to-start team-card-badges-no-data-badge"
    }, "Tracking diabled")), /*#__PURE__*/React.createElement("div", {
      className: "team-card-footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "team-card-footer-checkin-time"
    }, teamCardValue.clockInTime == 0 && teamCardValue.workSec > 0 ? "-" : teamCardValue.clockInTime ? moment(new Date(teamCardValue.clockInTime)).format("hh:mm a") : "00:00"), /*#__PURE__*/React.createElement("div", {
      className: "team-card-footer-chart"
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      className: "team-card-footer-stop",
      now: 100
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user9 = teamCardValue.user) === null || _teamCardValue$user9 === void 0 ? void 0 : _teamCardValue$user9.userId, "-worked-hours"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Productive")
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      className: "team-card-footer-online",
      now: teamCardValue.productivityPercentage,
      key: 1,
      isChild: true
    })), /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user10 = teamCardValue.user) === null || _teamCardValue$user10 === void 0 ? void 0 : _teamCardValue$user10.userId, "-stop-hours"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Unproductive")
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      className: "team-card-footer-stop",
      now: teamCardValue.unproductiveSec,
      key: 2,
      isChild: true
    })), /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "".concat(teamCardValue === null || teamCardValue === void 0 ? void 0 : (_teamCardValue$user11 = teamCardValue.user) === null || _teamCardValue$user11 === void 0 ? void 0 : _teamCardValue$user11.userId, "-break-hours"),
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-top"
      }, "Neutral")
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      className: "team-card-footer-break",
      now: teamCardValue.neutralSec,
      key: 2,
      isChild: true
    })))), /*#__PURE__*/React.createElement("div", {
      className: "team-card-footer-hourworked-time"
    }, teamCardValue.workedTime)), /*#__PURE__*/React.createElement("div", {
      className: "team-card-footer-split"
    }, /*#__PURE__*/React.createElement("p", {
      className: "team-card-footer-split-paragraph"
    }, "Checked-in"), /*#__PURE__*/React.createElement("p", {
      className: "team-card-footer-split-paragraph-hours-worked"
    }, "Hours worked"))));
  })))), myTeamDetailsDataFilter.length === 0 ? null : /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, filterId == "all" && !isAllLoaded || filterId == "start" && !isCurrentlyWorkingLoaded || filterId == "break" && !isBreakLoaded || filterId == "stop" && !isStopLoaded || filterId == "yet_to_start" && !isYetToStartLoaded || filterId == "app_not_installed" && !isAppNotInstallLoaded || filterId == "leave" && !isLeaveLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "screenshot-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : !search && myTeamDetailsDataFilter !== null && myTeamDetailsDataFilter !== void 0 && myTeamDetailsDataFilter.length ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the team members") : null));
  setIsGettingData(false);
};
export default MyTeams;